<template>
    <div>
        <div class="container race-detail--wrapper" v-if="hasResults">
            <Classifica :data="data" />
        </div>
    </div>
</template>

<script>
    import Classifica from '../components/Classifica'
    import BaseRace from '../components/BaseRace'

    export default {
        extends: BaseRace,
        name: 'iframe-race',
        components: {
            Classifica,
        },
        data() {
            return {

            }
        },
        async mounted() {

        }, computed: {

        }, methods: {

        }
    }
</script>
